import { div } from "framer-motion/client"
import styles from "./styles.module.css";
import iStyles from "./iStyles.module.css";
import TextBoxComponent from "./TextBoxComponent";
import { Observer } from "mobx-react";
import { getMobileOperatingSystem } from "../constants/utils";
import MCQOption from "../screens/Questionare/MCQOption";
import QuestionareStore from "../stores/QuestionareStore";
import { useState } from "react";
import RatingSlider from "./RatingSlider";
import AudioPlayer from "./AudioPlayer";
import VideoPlayer from "./VideoPlayer";

const isiOS = getMobileOperatingSystem() === "iOS";

const IC_Component = ({item}) => {
    //caption
    //display text
    //helper text
    //image/ option/ select_type: text_area
    const [inputVal, setInputVal] = useState('')
    return (
      <Observer>
        {()=>{return(
          <div>
            {item.caption_text && (
                <p
                className={isiOS ? iStyles.QuestionLabel : styles.QuestionLabel}
              >
                {item.caption_text}
              </p>
            )}

            {(item.display_text && !item.image_file)&& (
              <p className={isiOS ? iStyles.Question : styles.Question} style={{paddingBottom: '1rem'}}>
                {item.display_text}
              </p>
            )}

            {item.helper_text && (
                <p
                className={isiOS ? iStyles.QuestionLabel : styles.QuestionLabel}
              >
                {item.helper_text}
              </p>
            )}    

            {/* image in case present */}
            {/* different styles for the two images */}
            <div>
              {(item.image_file && item.textbox_text==="breakscreen1") && (
                <div style={{display:"flex", justifyContent:"center"}}>
                  <img src={item.image_file} style={{maxWidth: '22rem'}} alt="" />
                </div>
                
              )}
              {(item.image_file && item.textbox_text==="break screen 2") && (
                <div style={{display:"flex", justifyContent:"center"}}>
                  <img src={item.image_file} className={styles.BreakImage2} style={{maxWidth: '28rem'}} alt="" />
                </div>
                
              )}
            </div>

            {/* render audio */}
            {item.select_type === "text_audio" && (
              <AudioPlayer audio_url={item.source_link} />
            )}

            {/* render video */}
            {item.select_type === "text_video" && (
              <VideoPlayer video_url={item.source_link} />
            )}

            {/* text field if select_type: text_textarea */}
            {item.select_type==="text_textarea" && (
              <TextBoxComponent inputKey={item.counter}/>
            )}

            {/* render optons if present */}
            {/* render options if select_type is multi_select or single_select */}
            {(item.select_type === "multi_select" || item.select_type === "single_select") && item.options.length > 0 && (
              <div style={{ height: '50vh', overflowY: 'auto' }}>
                {item.options.map((option, index) => (
                  <MCQOption
                    isSelected={
                      (QuestionareStore.selectedOptions[QuestionareStore.currentStepIndex] || []).includes(index)
                    }
                    key={index}
                    text={option.option_name}
                    onClick={() => QuestionareStore.selectOption(index)}
                  />
                ))}
              </div>
            )}
            
            {/* render slider if select_type is range_select_5 or range_select_10 */}
            {(item.select_type === 'range_select_5' || item.select_type === 'range_select_10') && (
              <RatingSlider
                ratingKey={item.counter}
                maxLimit={item.select_type === 'range_select_5' ? 5 : 10}
              />
            )}

        </div>
        )}}

      </Observer>
    )
}

export default IC_Component